module.exports = "<act-verify-method *ngIf=\"state == OTP_STATE.METHODS\" [methods]=\"methods\" [isLoading]=\"sendingRequestOtp\"\n  (selectMethod)=\"onSelectOtpMethod($event)\"></act-verify-method>\n<act-otp #otpChild *ngIf=\"state == OTP_STATE.OTP || state == OTP_STATE.SESSION_EXPIRE\" [isLoading]=\"isLoading\" [referenceCode]=\"otpReference\"\n  [selectedMethod]=\"selectedVerifyMethod\" [error]=\"errorMessage\" (clickResentOTP)=\"requestOTP($event)\" [sessionExpired]=\"sessionExpired\"></act-otp>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/verify-otp/verify-otp.component.html
// module id = 1096
// module chunks = 22